import { render, staticRenderFns } from "./DoorSidebarMenu.vue?vue&type=template&id=5de3ed1b&scoped=true&"
import script from "./DoorSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./DoorSidebarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de3ed1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5de3ed1b')) {
      api.createRecord('5de3ed1b', component.options)
    } else {
      api.reload('5de3ed1b', component.options)
    }
    module.hot.accept("./DoorSidebarMenu.vue?vue&type=template&id=5de3ed1b&scoped=true&", function () {
      api.rerender('5de3ed1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/DoorSidebarMenu.vue"
export default component.exports